var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1v14h16V1zm6 9V7h4v3zm4 1v3H6v-3zm0-8v3H6V3zM5 3v3H1V3zM1 7h4v3H1zm10 0h4v3h-4zm0-1V3h4v3zM1 11h4v3H1zm10 3v-3h4v3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/table.svg";